/**
 * Shows the actual deposit amount next to the full price on cart line items
 * that have SPD's instalment option selected, on both the full cart page and
 * the cart drawer - e.g. "£6,497.50 £12,995.00" (deposit prominent, full
 * price struck through), matching the pattern lillicoco.com's theme uses.
 *
 * This is purely a DISPLAY calculation. Shopify's own cart data
 * (final_line_price etc.) is never touched by SPD at the cart stage - see
 * `payments-option.md` / project memory - the real split only happens at
 * Checkout, where SPD generates a separate invoice for the deposit amount.
 * Checked lillicoco.com's own /cart.js the same way: their cart total at the
 * bottom stays full price too, even though their line price cell shows the
 * deposit - so this script deliberately does the same: recompute per line,
 * leave the cart's overall subtotal/total alone.
 *
 * How the deposit % is found: rather than matching SPD's user-editable label
 * text (which differs per store - AJO uses "Initial installment payment:",
 * lillicoco uses "Pay today (first instalment):" for the very same app), this
 * looks for the customization-option value itself: whichever <dd> in the row
 * holds a plain "NN%" or "NN.NN%" string. That's controlled by the deposit
 * percentage set up in SPD's own dashboard, not by store-editable copy, so
 * it stays correct if the label wording is ever changed here.
 *
 * Same re-render problem as spd-klarna-option.js: cart line rows get replaced
 * wholesale on quantity changes / AJAX cart updates, so this uses a
 * permanent document-level MutationObserver and re-scans fresh each time,
 * rather than trusting specific node references to still be live. Price
 * spans are marked with a data attribute once processed so a settled row
 * isn't repeatedly rewritten.
 */
(function () {
  var PERCENT_RE = /^\s*(\d+(?:\.\d+)?)\s*%\s*$/;
  // window.money_format is set from the shop's real `shop.money_format`
  // setting by the inline script in snippets/global-script.liquid, which
  // runs synchronously before this (deferred) script - falls back to a
  // plain GBP format only if that's somehow missing.
  var MONEY_FORMAT = window.money_format || '£{{amount}}';

  function findDepositPercent(row) {
    var dds = row.querySelectorAll('dd');
    for (var i = 0; i < dds.length; i++) {
      var match = dds[i].textContent.match(PERCENT_RE);
      if (match) return parseFloat(match[1]) / 100;
    }
    return null;
  }

  function parseMoneyToCents(text) {
    var cleaned = text.replace(/[^\d.,]/g, '').replace(/,/g, '');
    var value = parseFloat(cleaned);
    return isNaN(value) ? null : Math.round(value * 100);
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, MONEY_FORMAT);
    }
    // Fallback if Shopify.formatMoney isn't loaded on this page for some
    // reason - plain GBP formatting, matches the site's only active currency.
    return '£' + (cents / 100).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function processRow(row) {
    var pct = findDepositPercent(row);
    if (pct === null) return;

    var priceEls = row.querySelectorAll('.price:not([data-spd-deposit-done])');
    priceEls.forEach(function (el) {
      var cents = parseMoneyToCents(el.textContent);
      if (cents === null) return;

      var depositCents = Math.round(cents * pct);
      el.innerHTML =
        '<ins>' + formatMoney(depositCents) + '</ins> ' +
        '<del>' + formatMoney(cents) + '</del>';
      el.classList.add('spd-deposit-price');
      el.setAttribute('data-spd-deposit-done', '1');
    });
  }

  function scan() {
    document.querySelectorAll('.cart-item').forEach(processRow);
  }

  function start() {
    scan();
    new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
